import {Component, OnInit, OnDestroy, AfterViewInit} from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import {DataService} from '../../../../Services/data.service';
import { Router } from '@angular/router';
import { StorageService } from '../../../../Services/storage.service';
import { AppConfigService } from '../../../../Services/app-config.service';
import { ResponseModel } from '../../../../DataModels/response-model';
import { DateFilterService } from '../../../../Services/dateFilter.service';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { PagerStateService } from '../../../../Services/pager-state.service';
import { NgbpaginationConfigService } from '../../../../Services/ngbpagination-config.service';
import { BsToastService } from '../../../../Services/bs-toast-service';
import {Title} from '@angular/platform-browser';
import {ListPageBase} from '../../../list-page-base';

@Component({
  selector: 'app-account-list',
  templateUrl: './account-list.component.html',
  styleUrls: ['./account-list.component.css'],
  standalone: false
})
export class AccountListComponent extends ListPageBase implements OnInit, OnDestroy, AfterViewInit {
  constructor(
    private table: DataService,
    private toastr: BsToastService,
    private storage: StorageService,
    private dateFilter: DateFilterService,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService,
    private titleService: Title
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  public pageOptions: object;
  vm: any = [];
  accountCount = 0;
  isLoaded = false;

  // legacy angular-datatables removed; using shared DataTableComponent
  dataTableReady = false;



  ngOnInit(): void {
    this.vm.list = [];
    this.getData();
  }

  ngAfterViewInit() {
    this.titleService.setTitle($localize`:Accounts List @@accountsList:Accounts List`);
  }

  // no legacy datatable config; using shared DataTableComponent
  ngOnDestroy() {
    // no dtTrigger to clean up
  }


  getData() {
    let paramString =
      '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString +=
      '&fromDate=' +
      (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString +=
      '&toDate=' +
      (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.table.getApiListData('account' + paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
        this.accountCount = result.totalRecords;
        this.isLoaded = true;
      },
      (error: HttpErrorResponse) => {
        // this.toastr.error($localize`:Error loading Account Data @@errorloadingAccountData:Error loading Account Data`);
        console.log(error);
      },
      () => {}
    );
  }

  onNavigate(aID: string) {
    this.router.navigate(['admin/account-form', { id: aID }]).then();
  }

  // ----------------- Server side paging --------------------

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    let paramString =
      '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString +=
      '&fromDate=' +
      (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString +=
      '&toDate=' +
      (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.table.getApiListData('account' + paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
        this.isLoaded = true;
      },
      (error: HttpErrorResponse) => {
        // this.toastr.error($localize`:Error loading Account Data @@errorloadingAccountData:Error loading Account Data`);
        console.log(error);
      },
      () => {}
    );
  }

  serverSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }
}
